import { defineStore } from 'pinia'
import { api } from '@/plugins/api'

const userDefault = {
  firm: null,
  user: null,
  emailAddress: null,
  username: null,
  firstName: '',
  lastName: '',
  fullName: '',
  isInactive: false,
  timezone: 5,
  language: 1,
  roles: [],
  guid: null,
  profileUrl: null,
  employeeId: null,
  password: null,
  password2: null
}

export const userStore = defineStore('user', {
  state: () => ({
    user: JSON.parse(JSON.stringify(userDefault)),
    users: {
      count: 0,
      items: []
    },
    loading: {
      user: false,
      users: false,
      userFirms: false
    },
    listParams: {
      page: 1,
      pageSize: 10,
      filterOptions: null,
      filterBy: null,
      sortBy: 'asc',
      orderBy: 'user',
      searchTerm: ''
    },
    foundUsers: null,
    userFirms: []
  }),
  actions: {
    resetUser(firm) {
      this.user = JSON.parse(JSON.stringify(userDefault))
      if (firm) {
        this.user.firm = firm
      }
    },
    setUser(data) {
      this.user[data.name] = data.value
    },
    setListParam(data) {
      this.listParams[data.name] = data.value
    },
    setLoading(data) {
      this.loading[data.name] = data.value
    },
    setPrimaryFirm(firm) {
      this.userFirms.forEach((element) => {
        element.isPrimary = 0
        if (parseInt(element.firm) === parseInt(firm)) {
          element.isPrimary = 1
          element.isSave = true
        }
      })
    },
    setUserFirm(data) {
      this.userFirms.push(data)
    },
    async getUsers(options) {
      this.users = {
        count: 0,
        items: []
      }
      this.loading.users = true
      this.users = await api.get('user/users', options)
      this.loading.users = false
      console.log('Got Users', this.users)
      return this.users
    },
    async getUser(uid) {
      this.resetUser()
      this.loading.user = true
      this.user = await api.get(`user/profile?username=${uid}`)
      this.loading.user = false
      console.log('Got User', this.user)
      return this.user
    },
    async saveUser() {
      return await api.post('user/saveUser', this.user)
    },
    async verifyUsername(username) {
      return await api.get(`user/verifyUsername?username=${username}`)
    },
    async saveCredentials(data) {
      return await api.post(`user/saveCredentials`, data)
    },
    async getUserCurrentFirms(user) {
      this.userFirms = []
      this.loading.userFirms = true
      this.userFirms = await api.get(`user/userFirms?user=${user}`)
      this.loading.userFirms = false
      console.log('Got User Current Firms', this.userFirms)
      if (this.userFirms) {
        this.userFirms.forEach((firm) => {
          firm.user = user
          firm.isPrimary = firm.isPrimary ? 1 : 0
        })
      }
      return this.userFirms
    },
    async getUserFirms(data) {
      this.userFirms = []
      this.loading.userFirms = true
      this.userFirms = await api.get(`firm/userFirms?user=${data.user}&firm=${data.firm}`)
      this.loading.userFirms = false
      if (this.userFirms) {
        this.userFirms.forEach((userFirm) => {
          userFirm.user = data.user
          userFirm.checked = true
          if (userFirm.userFirm === null) {
            userFirm.checked = false
          }
        })
      }
      console.log('Got User Firms', this.userFirms)
      return this.userFirms
    },
    async saveUserFirms(firms) {
      await api.post(`firm/saveUserFirms`, firms)
    },
    removeUserFirm(id) {
      this.userFirms = this.userFirms.filter((x) => parseInt(x.firm) !== parseInt(id))
    },
    async pushUser(data) {
      await api.post('data/pushUser', data)
    },
    async moveUser(data) {
      return await api.post('user/moveUser', data)
    },
    async updateUserParams(data) {
      return await api.post('user/updateUserParams', data)
    }
  }
})
